<template>
    <Container leftWidth="200px">
        <template v-slot:header>
            <TopBanner></TopBanner>
        </template>
        <template v-slot:left>
            <div class="left-menu">
                <slot name="menu"></slot>
            </div>
        </template>
        <div class="scroll-container">
            <div class="page-content">
                <router-view></router-view>
            </div>
        </div>
    </Container>
</template>
<script>
import TopBanner from "../components/TopBanner.vue";
export default {
    name: "IndexLayout",
    components: { TopBanner },
};
</script>
<style></style>
